import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetStopWordsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStopWordsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly stopWords: ReadonlyArray<string> } | null } | null };


export const GetStopWordsDocument = gql`
    query GetStopWords {
  currentUser {
    currentCompany {
      stopWords
    }
  }
}
    `;

/**
 * __useGetStopWordsQuery__
 *
 * To run a query within a React component, call `useGetStopWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStopWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStopWordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStopWordsQuery(baseOptions?: Apollo.QueryHookOptions<GetStopWordsQueryPage, GetStopWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStopWordsQueryPage, GetStopWordsQueryVariables>(GetStopWordsDocument, options);
      }
export function useGetStopWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStopWordsQueryPage, GetStopWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStopWordsQueryPage, GetStopWordsQueryVariables>(GetStopWordsDocument, options);
        }
export function useGetStopWordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStopWordsQueryPage, GetStopWordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStopWordsQueryPage, GetStopWordsQueryVariables>(GetStopWordsDocument, options);
        }
export type GetStopWordsQueryHookResult = ReturnType<typeof useGetStopWordsQuery>;
export type GetStopWordsLazyQueryHookResult = ReturnType<typeof useGetStopWordsLazyQuery>;
export type GetStopWordsSuspenseQueryHookResult = ReturnType<typeof useGetStopWordsSuspenseQuery>;
export type GetStopWordsQueryResult = Apollo.QueryResult<GetStopWordsQueryPage, GetStopWordsQueryVariables>;